var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordLogoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.3,3.7C3.2,3.7,3,3.9,3,4.1c0,0.2,0.2,0.3,0.3,0.3s0.3-0.2,0.3-0.3C3.7,3.9,3.5,3.7,3.3,3.7z M4.4,3.7 c-0.2,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.3,0.3c0.2,0,0.3-0.2,0.3-0.3S4.6,3.7,4.4,3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,1.3H1.8c-0.3,0-0.7,0.3-0.7,0.6v4c0,0.3,0.3,0.6,0.7,0.6h3.5L5.1,5.9l0.4,0.3l0.4,0.3l0.7,0.5V1.9 C6.6,1.5,6.3,1.3,6,1.3z M4.7,5.1c0,0-0.1-0.1-0.2-0.2c0.4-0.1,0.5-0.3,0.5-0.3C5,4.6,4.9,4.7,4.7,4.7C4.6,4.8,4.4,4.8,4.3,4.8 C4,4.9,3.8,4.9,3.5,4.8C3.3,4.8,3.2,4.8,3,4.7C3,4.7,2.9,4.7,2.8,4.6c0,0,0,0-0.1,0l0,0C2.7,4.6,2.7,4.6,2.7,4.6s0.2,0.2,0.5,0.3 C3.2,5,3,5.1,3,5.1c-0.7,0-0.9-0.4-0.9-0.4C2.1,3.7,2.6,3,2.6,3C3,2.6,3.4,2.6,3.4,2.6l0.1,0.1C2.9,2.9,2.6,3.1,2.6,3.1 S2.7,3,2.8,3c0.4-0.1,0.6-0.2,0.7-0.2h0.1c0.2,0,0.4-0.1,0.6,0c0.3,0.1,0.6,0.1,0.9,0.3c0,0-0.2-0.2-0.8-0.4l0.1-0.1 c0,0,0.4,0,0.9,0.3c0,0,0.4,0.8,0.4,1.7C5.7,4.7,5.4,5.1,4.7,5.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogoBg);
export default __webpack_public_path__ + "static/media/discord-logo-bg.6180b66da42b9ef4dea26be51f4b9dc2.svg";
export { ForwardRef as ReactComponent };